import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagenotfount',
  templateUrl: './pagenotfount.component.html',
  styleUrls: ['./pagenotfount.component.css']
})
export class PagenotfountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
